import { useState } from 'react';

function IconLock() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

function IconEye({ open }) {
  if (open) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="currentColor" strokeWidth="1.7" />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.7" />
      </svg>
    );
  }
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M3 3l18 18M10.5 10.5a3 3 0 0 0 3 3M5.2 5.2C3.1 6.4 1.5 8.1 1 9.5c0 0 4 7 11 7 1.2 0 2.3-.2 3.3-.5M8.2 4.2C9.3 3.8 10.6 3.5 12 3.5c7 0 11 6.5 11 6.5-.2.4-1.1 1.6-2.4 2.8"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * The rider portal's password field, with its eye always there (Rio,
 * 2026-09-28: every password field reveals and hides what is typed). The
 * sign-in page's own field, moved here so the pages that ask for a password
 * draw one field; styled by `driverLoginPremium.css`.
 */
export default function DriverPasswordField({ id, label, value, onChange, autoComplete, error, disabled = false }) {
  const [shown, setShown] = useState(false);
  const errorId = `${id}-error`;

  return (
    <div className="dp-login-field">
      <label className="dp-login-label" htmlFor={id}>
        {label}
      </label>
      <div className="dp-login-input-wrap">
        <span className="dp-login-iconbox" aria-hidden>
          <IconLock />
        </span>
        <input
          className="dp-login-input"
          id={id}
          name={id}
          type={shown ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          placeholder="••••••••"
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          required
        />
        <button
          type="button"
          className="dp-login-input-toggle"
          onClick={() => setShown((s) => !s)}
          aria-label={shown ? 'Hide password' : 'Show password'}
          aria-pressed={shown}
          disabled={disabled}
        >
          <IconEye open={!shown} />
        </button>
      </div>
      {error ? (
        <p className="dp-login-error" id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
